import { useContext } from 'react';
import { QueryClient, QueryClientContext, useQuery } from '@tanstack/react-query';

import { appBootstrapV2QueryOptions } from '../../api/cache/appContextV2QueryOptions';
import { bagWords, type BagWords } from '../bagWords';

/** Used only when no QueryClientProvider is mounted. It never fetches. */
const noProviderClient = new QueryClient();

/**
 * The bag word for this app, from the V2 bootstrap. See `bagWords`.
 *
 * It reads the same cached bootstrap every host already loads, so it adds no
 * request. It gives "bag" until the bootstrap arrives. It also works with no
 * QueryClientProvider (it gives "bag"), because the bag drawer and bag buttons
 * render in hosts that do not all mount one.
 */
export function useBagWords(): BagWords {
  const client = useContext(QueryClientContext);
  const { data: noun } = useQuery(
    {
      ...appBootstrapV2QueryOptions(),
      select: (bootstrap) => bootstrap.app?.bagNoun,
      enabled: !!client,
    },
    client ?? noProviderClient,
  );
  return bagWords(noun);
}
